import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { Activity } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Floating, slim puls-bar that sits under the main header (sticky) and shows
 * live counts as small discreet links. Hidden on admin/mod routes.
 */
export default function PulsBar() {
  const [puls, setPuls] = useState(null);
  const location = useLocation();

  useEffect(() => {
    axios.get(`${API}/puls`).then(r => setPuls(r.data)).catch(() => {});
  }, [location.pathname]);

  if (!puls) return null;
  if (location.pathname.startsWith("/mod")) return null;

  const items = [
    { to: "/anslagstavla", label: "anslag", value: puls.anslag },
    { to: "/evenemang", label: "evenemang", value: puls.evenemang },
    { to: "/foreningar-evenemang", label: "föreningar", value: puls.foreningar },
    { to: "/foretag", label: "företag", value: puls.foretag },
  ];

  return (
    <div data-testid="puls-bar" className="bg-bone border-b border-warm-border">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-x-4 gap-y-1 py-1.5 overflow-x-auto whitespace-nowrap text-[11px] sm:text-xs">
          <Link
            to="/#bygdepuls"
            data-testid="puls-bar-label"
            aria-label="Till Bygdepuls"
            className="inline-flex items-center gap-1.5 text-bark/40 hover:text-falu no-underline font-body font-semibold uppercase tracking-[0.15em] shrink-0 transition-colors"
          >
            <Activity size={11} className="text-falu" /> Puls
          </Link>
          {items.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              data-testid={`puls-link-${item.label}`}
              className="text-bark/60 hover:text-falu no-underline transition-colors shrink-0"
            >
              <span className="text-ink font-semibold">{item.value ?? 0}</span> {item.label}
            </Link>
          ))}
          {/* Build 96.5 — "Senast: <datum>" borttagen ur kopfraden (var en gammal UI-leik). */}
        </div>
      </div>
    </div>
  );
}
